<template>
  <div class="title-icon">
    <div class="horizontal fb fb-cross-center">
      <i v-if="iconType" class="iconfont font-100 c-C0C0C0">&#xe651;</i>
      <img class="w-28 h-28" v-if="iconImage" :src="iconImage" alt="" />
      <div class="ml-10">
        <p class="font-26 text-bold c-171A1D" v-if="title">{{ title }}</p>
        <p class="font-24 c-171A1D-40" v-if="time">{{ time }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    iconType: {
      type: [Number, String],
      default: ''
    },
    iconImage: {
      type: String,
      default: require('@/assets/images/guardian/icon-face.png')
    },
    title: {
      type: String,
      default: '标题'
    },
    time: {
      type: String,
      default: ''
    }
  }
}
</script>

<style></style>
